// extracted by mini-css-extract-plugin
module.exports = {"title":"FileLink_title__lcupo","clickable":"FileLink_clickable__1yLU8"};